// A group with a blank name holds top-level pages: every docs surface renders
// its articles with no folder above them, and their URLs carry no group segment.
export function isLooseGroup(group: { name?: string | null }): boolean {
	return typeof group.name === "string" && !group.name.trim()
}

// What an AI prompt calls a group, so an unnamed one never reads as a blank line.
export function docsGroupPromptName(group: { name?: string | null }): string {
	return isLooseGroup(group)
		? "(top-level pages, no folder)"
		: (group.name ?? "")
}
